// extracted by mini-css-extract-plugin
export default {"title":"taskTitle_title__v7MIW","titleDisabled":"taskTitle_titleDisabled__IdrEw","titleAbled":"taskTitle_titleAbled__PQgCB"};